export default "__VITE_ASSET__82c7be3c__"